export default "<div>Logging out...</div>\n"